import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Container,
  Grid,
  Typography,
} from '@mui/joy'
import Avatar from '@mui/joy/Avatar'
import FontDownloadIcon from '@mui/icons-material/FontDownload'
import ListItemContent from '@mui/joy/ListItemContent'
import FontSelector from '../../font/FontSelector'
import ColorPicker from '../../ColorPicker'
import React, { useEffect, useState } from 'react'
import {
  useGetStoreDataQuery,
  useUpdateStoreMutation,
} from '../../../services/branding'

function TextSettings() {
  const { data: store } = useGetStoreDataQuery()

  const [updateStore] = useUpdateStoreMutation({
    fixedCacheKey: 'shared-delete-reward',
  })

  const [textColor, setTextColor] = useState<string>(store!.textColor)

  useEffect(() => {
    if (textColor !== store!.textColor) {
      updateStore({ textColor })
    }
  }, [textColor])

  return (
    <>
      <Accordion>
        <AccordionSummary>
          <Avatar color="primary">
            <FontDownloadIcon />
          </Avatar>
          <ListItemContent>
            <Typography level="title-md">Szöveg</Typography>
            <Typography level="body-sm">
              Font és egyéb szöveg beállítások
            </Typography>
          </ListItemContent>
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="xs" sx={{ pt: 2 }}>
            <Card>
              <Container maxWidth="xs">
                <FontSelector />
              </Container>
            </Card>
          </Container>

          <Container maxWidth="xs">
            <Card sx={{ mt: 2 }}>
              <label style={{ paddingLeft: 12 }}>Betű színe</label>
              <Grid
                container
                direction="column"
                alignItems="center"
                spacing={-3}
              >
                <ColorPicker
                  pickedColor={textColor}
                  setPickedColor={setTextColor}
                  changeCompleted={() => {}}
                />
              </Grid>
            </Card>
          </Container>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default TextSettings
